import React from 'react';
import './PriceBar.css';

interface PriceBarProps {
  currentPrice: number;
  averagePrice: number;
  standardDeviation: number;
}

const PriceBar: React.FC<PriceBarProps> = ({ currentPrice, averagePrice, standardDeviation }) => {
  const minPrice = averagePrice - standardDeviation;
  const maxPrice = averagePrice + standardDeviation;
  
  // Calculate the position of the current price as a percentage
  const position = ((currentPrice - minPrice) / (maxPrice - minPrice)) * 100;
  
  // Ensure position stays within 0-100%
  const clampedPosition = Math.min(100, Math.max(0, position));

  return (
    <div className="price-bar-container">
      <div className="price-bar">
        <div 
          className="price-indicator" 
          style={{ left: `${clampedPosition}%` }}
        />
        <div 
          className="current-price-label" 
          style={{ left: `${clampedPosition}%` }}
        >
          ${currentPrice.toLocaleString()}
        </div>
      </div>
      <div className="price-labels">
        <div className="price-label">
          <span className="label-text">Low</span>
          <span className="price-value">${minPrice.toLocaleString()}</span>
        </div>
        <div className="price-label">
          <span className="label-text">High</span>
          <span className="price-value">${maxPrice.toLocaleString()}</span>
        </div>
      </div>
      <div className="info-message">
        This bar shows the unit price compared to similar units in this building.
      </div>
    </div>
  );
};

export default PriceBar; 